import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import * as Actions from '../actions'

import EsdpMap from '../components/EsdpMap'

const RoutedEsdpMap = withRouter(EsdpMap)

class EsdpMapContainer extends Component {
  render () {
    // TODO: Strip router params from coming in to component
    // var { routeParams, ...otherProps } = this.props
    return (
      <RoutedEsdpMap {...this.props} />
    )
  }
}

function mapStateToProps (state, ownProps) {
  return {
    appMeta: state.appMeta,
    esdpMap: state.esdpMap,
    navigationInfo: state.navigationInfo,
    localization: ownProps.routeParams.localization,
    mapId: ownProps.routeParams.mapId
  }
}

export default connect(mapStateToProps, {...Actions})(EsdpMapContainer)



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/containers/EsdpMap.js